import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Login } from './pages'
import './assetes/style/global.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Base} from './components'
import ContextContainer from './context/ContextContainer';

function App() {
  return (
    <ContextContainer>
      <div className="w-full max-w-3xl m-auto bg-white shadow">
        <BrowserRouter>
          <Routes>
            <Route path="/p/*" element={<Base />} />
            <Route path="/" element={<Login />} />
          </Routes>
        </BrowserRouter>
        <ToastContainer
          position="top-right"
          rtl={true}
          hideProgressBar={false} newestOnTop
          closeOnClick theme='light'
          pauseOnFocusLoss
          draggable pauseOnHover
        />
      </div>
    </ContextContainer>
  );
}

export default App;
